.polycyBlock {
  color: #000;
  font-size: 11px;
  font-weight: 590;
  line-height: 13px;
  letter-spacing: -0.3px;
  text-align: center;
  border-radius: 16px;
  border: 1px solid var(--ed-border, #f3eddf);
  padding: 15px 10px;

  a {
    font-weight: 400;
    text-decoration: underline;
  }

  span {
    color: var(--ed-brand, #ba61fe);
    font-weight: 590;
  }
}

.polycyBlock.tariffV5 {
  color: #fff;

  span {
    color: #fff;
  }

  border: 1px solid var(--ed-border, rgba(243, 237, 223, 0.2));
}


// Dark mode
:global body.dark {
  :local {
    .polycyBlock {
      background-color: #181716;
      border-color: var(--ed-border, #3E3C3A);
      color: #fffbf2;
    }
  }
}

:global body.dark #secondScreenWrapper {
  :local {
    .polycyBlock {
      background-color: #2A2928;
    }
  }
}
